/* istanbul ignore file */
/**
 * Toast component theme configuration.
 */

export const toast = {
  root: {
    width: '400px',
    borderRadius: '{content.border.radius}',
    borderWidth: '0 0 0 0',
    transitionDuration: '{transition.duration}',
  },
  icon: {
    size: '16px',
  },
  content: {
    padding: '{overlay.popover.padding}',
    gap: '12px',
  },
  text: {
    gap: '0px',
  },
  closeButton: {
    width: '20px',
    height: '20px',
    borderRadius: '{border.radius.sm}',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      offset: '{focus.ring.offset}',
    },
  },
  closeIcon: {
    size: '12px',
  },
};
